"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const page_section_1 = __importDefault(require("~components/page-section"));
const react_1 = require("react");
const analytics_1 = require("@phishtool/analytics");
const products_1 = require("@phishtool/products");
const MSSPPricingSection = ({ title, productContent }) => {
    (0, react_1.useEffect)(() => {
        (0, analytics_1.logEvent)('Pricing Viewed', { variant: 'mssp' });
    }, []);
    return ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: "pricing", title: title, headerSpacer: ['x6', null, 'x9'], hasDivider: false, children: (0, jsx_runtime_1.jsx)(products_1.MSSPProductComparison, { productContent: productContent }) }));
};
exports.default = MSSPPricingSection;
